export const LOCATION_COLUMNS = [
    {id:"locationTitle",type:"text",title:"Location Title",placeholder:"Enter location title"},
    {id:"address",type:"text",title:"Address",placeholder:"Enter address"},
    {id:"city",type:"text",title:"City",placeholder:"Enter City"},
    {id:"state",type:"text",title:"State",placeholder:"Enter State"},
    {id:"gpsCords",type:"text",title:"GPS Coordinates",placeholder:"234,237"},
    {id:"postalCode",type:"number",title:"Postal Code",placeholder:"Enter postal code"},
]